<div [formGroup]="form" class="gup-C-numberRange gup-C-flexGroup -row -justifyBetween -alignCenter">

    <div class="gup-C-numberRange__startNumber gup-C-flexGroup__item -demi">
        <kal-form-field class="without-label">
            <kal-input [icon]="inputIcon"
                       [id]="id + '_start_Number'"
                       [label]="controlLabel"
                       [placeholder]="startPlaceholder"
                       [type]="inputType"
                       formControlName="startNumber">
            </kal-input>
        </kal-form-field>
    </div>

    <div *ngIf="!shouldDisplayNumberEnd; else displayNumberEndInputs"
         class="gup-C-numberRange__link gup-C-flexGroup__item">
        <a (click)="toggleNumberEnd()"
           *ngIf="!shouldDisplayNumberEnd"
           class="gup-O-link -secondary">
            Définir une plage
        </a>
    </div>

    <ng-template #displayNumberEndInputs>

        <div class="gup-C-flexGroup__item gup-C-numberRange__text">{{betweenLabel}}</div>

        <div class="gup-C-numberRange__endNumber gup-C-flexGroup__item -demi ">
            <kal-form-field class="without-label">
                <kal-input [icon]="inputIcon"
                           [id]="id + '_end_Number'"
                           [placeholder]="endPlaceholder"
                           [type]="inputType"
                           formControlName="endNumber">
                </kal-input>
            </kal-form-field>
        </div>

    </ng-template>
    <p *ngIf="form.hasError('invalidendNumber')"
       class="gup-O-msg -error">
        {{errorsMessage['invalidendNumber']}}
    </p>
</div>
